export default "images/safety.png";